





















import { Vue, Component, PropSync, Ref } from "vue-property-decorator"
import { getTimestamp } from "@/utils"
import { FormModel } from "ant-design-vue"

@Component({})
export default class DeployTimeModal extends Vue {
    @PropSync("visible", { type: Boolean }) visible_: boolean

    deployForm: any = {
        deploy_time: undefined
    }

    @Ref("deployForm")
    deployRef: FormModel

    async handleOk() {
        try {
            await this.deployRef.validate()
            const { deploy_time } = this.deployForm
            this.$emit("submit", deploy_time ? getTimestamp(deploy_time) : undefined)
            this.$emit("update:visible", false)
        } catch (error) {
            if (error) {
                this.$message.error(`${error}`)
            }
        }
    }
}
